module.exports = __webpack_public_path__ + "img/empty.29956d3f.png";